// @flow

import * as React from 'react';
import { css } from 'emotion';
import Colors from '../../../../styles/Colors';

type Props = {
  // text to be rendered in the label
  text: string,
  // customStyles is an optional object which is merged into the defaultStyles object before being applied to the label <div>
  // properties on the customStyles object which also exist on the defaultStyles object will be overwritten
  customStyles?: Object
};

const defaultStyles = {
  textTransform: 'uppercase',
  fontSize: 11,
  fontWeight: 600,
  padding: '5px 25px',
  borderRadius: 10,
  backgroundColor: Colors['@link-water'],
  color: Colors['@cornflower-blue'],
  '& :hover': css({ cursor: 'default' })
};

const mergeStyles = props => {
  return css(Object.assign({}, defaultStyles, props.customStyles));
};

export default class ColoredLabel extends React.PureComponent<Props> {
  render() {
    const { text, customStyles } = this.props;
    const styles = customStyles ? mergeStyles(this.props) : defaultStyles;

    return <div className={css(styles)}>{text}</div>;
  }
}
